{
  "common.loading": "Chargement...",
  "common.error": "Quelque chose s'est mal pass\u00e9",
  "common.retry": "R\u00e9essayer",
  "common.cancel": "Annuler",
  "common.save": "Enregistrer",
  "common.delete": "Supprimer",
  "common.edit": "Modifier",
  "common.post": "Publier",
  "common.follow": "Suivre",
  "common.following": "Abonn\u00e9s",
  "common.followers": "abonn\u00e9s",
  "common.likes": "j'aime",
  "common.posts": "publications",
  "common.signOut": "Se d\u00e9connecter",

  "feed.forYou": "Pour vous",
  "feed.following": "Abonn\u00e9s",
  "feed.whatsOnYourMind": "\u00c0 quoi pensez-vous ?",
  "feed.noPostsYet": "Pas encore de publications",
  "feed.trending": "Tendance sur Scroll",

  "compose.placeholder": "Quoi de neuf ?",
  "compose.posting": "Publication...",
  "compose.charLimit": "{count}/{max}",

  "profile.editProfile": "Modifier le profil",
  "profile.message": "Message",
  "profile.noPostsYet": "Pas encore de publications",
  "profile.noVideosYet": "Pas encore de vid\u00e9os",
  "profile.posts": "Publications",
  "profile.videos": "Vid\u00e9os",

  "bookmarks.title": "Signets",
  "bookmarks.empty": "Pas encore de signets",
  "bookmarks.emptyHint": "Enregistrez des publications pour plus tard en appuyant sur l'ic\u00f4ne de signet",

  "activity.title": "Activité",
  "activity.empty": "Pas encore d'activité",
  "activity.emptyHint": "Quand quelqu'un aime, répond ou vous suit, cela apparaîtra ici.",
  "activity.emptyFiltered": "Pas encore d'activité dans cette catégorie",
  "activity.today": "Aujourd'hui",
  "activity.thisWeek": "Cette semaine",
  "activity.earlier": "Plus tôt",
  "activity.filter.all": "Tout",
  "activity.filter.follows": "Abonnements",
  "activity.filter.replies": "Réponses",
  "activity.filter.mentions": "Mentions",
  "activity.filter.reposts": "Republications",
  "activity.followedYou": "vous a suivi",
  "activity.likedYourPost": "a aimé votre publication",
  "activity.repliedToYourPost": "a répondu à votre publication",
  "activity.mentionedYou": "vous a mentionné",
  "activity.repostedYourPost": "a republié votre publication",
  "activity.tippedYou": "vous a envoyé un pourboire",

  "settings.mutedWords": "Mots masqu\u00e9s",
  "settings.mutedWordsHint": "Les publications contenant des mots masqu\u00e9s seront cach\u00e9es",
  "settings.addWordPlaceholder": "Ajouter un mot ou une expression...",
  "settings.noMutedWords": "Pas encore de mots masqu\u00e9s",
  "settings.moderation": "Mod\u00e9ration du contenu",
  "settings.accessibility": "Accessibilit\u00e9",

  "onboarding.welcome": "Bienvenue sur Scroll",
  "onboarding.selectInterests": "S\u00e9lectionnez vos int\u00e9r\u00eats",
  "onboarding.suggestedFollows": "Cr\u00e9ateurs sugg\u00e9r\u00e9s",
  "onboarding.done": "Vous \u00eates pr\u00eat !",
  "onboarding.skip": "Passer",
  "onboarding.next": "Suivant",
  "onboarding.finish": "Commencer \u00e0 naviguer",

  "error.somethingWentWrong": "Quelque chose s'est mal pass\u00e9",
  "error.unexpectedError": "Une erreur inattendue s'est produite",
  "error.tryAgain": "R\u00e9essayer"
}
